import { render, staticRenderFns } from "./managersDcaAuth.vue?vue&type=template&id=55ec8a95&"
import script from "./managersDcaAuth.vue?vue&type=script&lang=js&"
export * from "./managersDcaAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports